import common from './common.json';
import auth from './auth.json';
import dashboard from './dashboard.json';
import settings from './settings.json';
import subscription from './subscription.json';
import admin from './admin.json';
import clients from './clients.json';
import calculator from './calculator.json';
import banks from './banks.json';
import applications from './applications.json';
import costs from './costs.json';
import support from './support.json';
import externalUpload from './externalUpload.json';
import landing from './landing.json';

export default {
  common,
  auth,
  dashboard,
  settings,
  subscription,
  admin,
  clients,
  calculator,
  banks,
  applications,
  costs,
  support,
  externalUpload,
  landing,
};
